import {NgModule} from '@angular/core';
import {NewsItemComponent} from './news-item.component';
import {NewsWidget} from './news-widget.component';
import {CommonModule} from '@angular/common';
import {DocumentNewsService} from '../service/document-news.service';
import {RouterModule} from '@angular/router';
import { PerfectScrollbarModule } from 'angular2-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'angular2-perfect-scrollbar';

const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


@NgModule({
  declarations: [NewsItemComponent, NewsWidget],
  providers: [DocumentNewsService],
  exports: [NewsWidget],
  imports: [CommonModule, RouterModule, PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG)]
})
export class NewsWidgetModule {

}




// WEBPACK FOOTER //
// ./src/app/shared/news-widget/news-widget.module.ts